/* global http formValidation formHelper preloader createElementToast */
const submitForm = {
	el: {
		html: document.documentElement,
		body: document.body,
		btnShowForm: document.querySelector('.js-show-form'),
		registerForm: document.querySelector('.js-form-register'),
		contactForm: document.querySelector('.js-form-contact'),
		embassadorForm: document.querySelector('.js-form-embassador'),
		jobOffersForm: document.querySelector('.js-form-job-offers'),
		groupReservationForm: document.querySelector('.js-form-group-reservation'),
		candidateTourismForm: document.querySelector('.js-form-candidate-tourism')
	},

	fxFormEvents(selector) {

		const form = document.querySelector(selector)

		form.addEventListener('submit', e => {
			const el = e.currentTarget
			e.preventDefault()

			const callback = response => {
				preloader.fxPreloaderRemove(form)

				switch (response.status) {
					case 409:
						// add toast
						createElementToast.fxCreateToastItem('warning', form.dataset.msgConflict)
						break
					case 500:
						// add toast
						createElementToast.fxCreateToastItem('warning', form.dataset.msgServer)
						break

					default:
						// add toast
						createElementToast.fxCreateToastItem('success', form.dataset.toastCopySuccess)
						break
				}
			}

			if (formValidation.fxValidate(el)) {
				preloader.fxPreloaderAdd(form)

				// get language that has to be sent to api
				const languageParameter = this.el.body.getAttribute('data-language')
				http.fxPost(el.getAttribute('action'), formHelper.fxFormToJson(el), callback, languageParameter)
			}
		})
	},

	fxShowForm(e) {
		let currentSection = e.currentTarget.closest('.content'),
			nextSection = currentSection.nextElementSibling

		currentSection.classList.add('d-none')
		nextSection.classList.remove('d-none')
	},

	init() {
		this.el.registerForm && this.fxFormEvents('.js-form-register')
		this.el.contactForm && this.fxFormEvents('.js-form-contact')
		this.el.embassadorForm && this.fxFormEvents('.js-form-embassador')
		this.el.jobOffersForm && this.fxFormEvents('.js-form-job-offers')
		this.el.groupReservationForm && this.fxFormEvents('.js-form-group-reservation')
		this.el.candidateTourismForm && this.fxFormEvents('.js-form-candidate-tourism')

		this.el.btnShowForm && this.el.btnShowForm.addEventListener('click', e => this.fxShowForm(e))

	}
}

submitForm.init()